export default __webpack_public_path__ + "static/media/cabbage.867d2421.png";